import { Component, Input, OnInit } from '@angular/core';
import { AccountDTO } from '@data/auth/AccountDTO';
import { MenuItem } from '@data/common/MenuItem';
import { Select, Store } from '@ngxs/store';
import { ApplicationSelectors } from '@shared/store/application/application.selectors';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false
})
export class TopBarComponent implements OnInit {
  public user$: Observable<AccountDTO> = this.store.select(AuthSelectors.getCurrentLogged);
  public featureTitleKey$: Observable<string> = this.store.select(ApplicationSelectors.featureTitleKey);
  public hasUnreadConversations$: Observable<boolean> = this.store.select(AuthSelectors.hasUnreadConversations);

  @Input()
  public showSidebar: boolean = true;

  public collapsed: boolean = true;

  public isAdmin: boolean = false;
  public isTriagist: boolean = false;
  public isSuperUser: boolean = false;

  public toggle(): void {
    this.collapsed = !this.collapsed;
  }

  constructor(private readonly store: Store) {
  }


  ngOnInit(): void {
    this.isAdmin = this.store.selectSnapshot(AuthSelectors.isAdmin);
    this.isTriagist = this.store.selectSnapshot(AuthSelectors.isTriagist);
    this.isSuperUser = this.store.selectSnapshot(AuthSelectors.isSuperUser);
  }
}
